/**
 * 在 JS 里读设计 token。
 *
 * 绝大多数地方用 Tailwind 类就够了。这个函数是给**必须把色值当字符串交出去**
 * 的场合用的 —— 目前只有 Leaflet：它画圆和图钉时要的是 `'#1c4f6e'` 这样的值，
 * 接不了 class。
 *
 * 在此之前这些色值是直接抄在组件里的 hex 字面量，改配色时会漏掉地图，
 * 于是地图上的围栏还是旧颜色。从 :root 上读就不会漏。
 */
export function token(name: string, fallback = ''): string {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}
